import React from 'react';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  makeStyles,
  Theme,
} from '@material-ui/core';
import { AccordionProps } from '@material-ui/core/Accordion';
import clsx from 'clsx';

import { Image, Typography } from '../../atoms';
import { ChevronDown as ChevronDownIcon } from '../../icons';

export interface ExpandSectionProps extends AccordionProps {
  imageUrl?: string;
  sectionDescription?: string;
  sectionName: string | React.ReactNode;
  translate: any;
}

const useStyles = makeStyles((theme: Theme) => ({
  expandSection: {},

  summary: {
    padding: theme.spacing(0, 2.5, 0, 2),
  },

  summaryImage: {
    display: 'none',
  },

  [theme.breakpoints.up('sm')]: {
    summary: {
      padding: 0,

      '&:hover': {
        '& .MuiIconButton-root': {
          backgroundColor: theme.palette.primary.main,
        },

        '& .fd-icon svg': {
          color: theme.palette.common.white,
        },
      },
    },

    summaryImage: {
      display: 'block',
      marginRight: theme.spacing(2),
      minWidth: '72px',
      boxSizing: 'content-box',
      objectFit: 'cover',
    },
  },
}));

export function ExpandSection(props: ExpandSectionProps): JSX.Element {
  const {
    children,
    className = '',
    imageUrl = '',
    sectionDescription = '',
    sectionName,
    translate,
    ...rest
  } = props;
  const classes = useStyles();

  const sectionNameElement =
    typeof sectionName === 'string' ? (
      <Typography variant="h2">{sectionName}</Typography>
    ) : (
      sectionName
    );

  const expandSectionStyles = clsx('fd-accordion', className);
  const sectionSummaryStyles = clsx('fd-accordion__summary', classes.summary);

  return (
    <Accordion {...rest} className={expandSectionStyles}>
      <AccordionSummary
        aria-label={translate('Global_ExpandSection')}
        className={sectionSummaryStyles}
        expandIcon={<ChevronDownIcon />}
        role="tab"
      >
        {!!imageUrl && (
          <Image
            className={classes.summaryImage}
            dimensions={[72, 72]}
            src={imageUrl}
          />
        )}

        <div>
          {sectionNameElement}
          {sectionDescription && (
            <Typography variant="body2">{sectionDescription}</Typography>
          )}
        </div>
      </AccordionSummary>

      <AccordionDetails role="tabpanel">{children}</AccordionDetails>
    </Accordion>
  );
}
